import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';

const ChoiYoonJin = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "박문영🖤최윤진 결혼합니다.";
    const openDesc = "5월 3일 오후 3시";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/147/thumb.jpg";

    const lng = 128.662133;
    const lat = 35.8823523;

    const placeTelNum = "053-282-2000";

    const forCar = "·  호텔 지상 및 지하 주차장\n총 450여 대 주차, 1시간 30분 무료 주차 가능\n\n·  제2주차장 (홈플러스 동촌점 3층)\n총 600여 대 주차, 무료 주차, 5분 간격 셔틀버스 운영\n\n·  강변 공용주차장\n총 400여 대 주차, 무료 주차, 5분 간격 셔틀버스 운영"
    const forBus = "·  퀸벨호텔 정류장 앞\n618, 719, 805, 808, 818, 836, 980, 동구1, 동구2, \n동구3\n\n·  퀸벨호텔 정류장 건너\n618, 719, 805, 808, 818, 836, 980, 동구1-1, 동구2, \n동구3"
    const forSubway = "·  지하철 1호선 하양방면 해안역 3번 출구 (50m 전방)";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 핑크B
        concept: "SUMMER",
        titleColor: "#ff8faf",
        pointColor: "#ff8faf",
        btnBgColor: "#ff8faf",
        fontColor: "#fff",
        btnFontColor: "#ffffff",
        chatBgColor: "#fff5f9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const title = "저희 결혼합니다.";
    
    const msg1 = "함께 맞이하는 여덟 번째 봄날에\n영원을 약속하려 합니다.";
    const msg2 = "따스하게 비쳐주는 봄 햇살처럼\n평생 동안 서로를 보듬고 사랑하겠습니다."
    const msg3 = "귀한 시간 내주시어 함께 축복해 주시면\n감사하겠습니다."


    // const parents = [
    //     {groom : "❁박금주 · 이윤실의 장남"},
    //     {bride : "이학두 · 최경숙의 차녀"}
    // ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "박문영",
            bank: "카카오뱅크",
            accountNumber : "3333-11-5606250",
            isKakao : true,
            kakaoUrl: "https://qr.kakaopay.com/FUJpjq3fv"
        }
        ,{
            role: "신랑 부",
            name: "박영현",
            bank: "농협은행",
            accountNumber : "352-1337-9396-23",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "장영희",
            bank: "국민은행",
            accountNumber : "861501-01-331688",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "최윤진",
            bank: "국민은행",
            accountNumber : "644602-04-286587",
            isKakao : true,
            kakaoUrl: "https://qr.kakaopay.com/Ej7jMRDzk"
        }
        ,{
            role: "신부 부",
            name: "최상호",
            bank: "새마을금고",
            accountNumber : "9003-1986-7139-5",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "우정희",
            bank: "국민은행",
            accountNumber : "730202-01-097513",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "그럼 기억해",
            brideAnswer: "어떻게 잊어"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "너무 설렌다",
            brideAnswer: "두근두근해"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "내가 잘할게",
            brideAnswer: "나도 잘할게"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "행복합시다",
            brideAnswer: "잘살자 우리"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "축하해줘요",
            brideAnswer: "많이많이🤍"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "박문영",
            call: "010-6353-9156"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "이명원",
        //     call: "010-3584-6149"
        // }
        // ,{
        //     role: "신랑 모",
        //     name: "이윤실",
        //     call: "010-8773-5752"
        // }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "최윤진",
            call: "010-6487-5898"
        }
        // ,{
        //     role: "신부 부",
        //     name: "이학두",
        //     call: "010-2513-9013"
        // }
        // ,{
        //     role: "신부 모",
        //     name: "최경숙",
        //     call: "010-8818-5050"
        // }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        // #ff5786

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#ff8faf"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Summer welcomeLineHeight={"1.5em"} weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.groomNameEn)} brideNameEn={getRemoveSpaceName(weddingData.brideNameEn)} color={"#ff8faf"} letteringFontColor={"#ff8faf"} dateColor={"#ff8faf"} bottom={"18%"} bottom2={"9.5%"} dateBottom={"87.7%"} top={"0.5%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList  fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forSubway={forSubway} forCar={forCar} forBus={forBus} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default ChoiYoonJin;